import React, {
  useState, useEffect, useContext, createContext,
} from 'react';

export const Matrix = createContext(); // context === redux sama-sama state management
function Index(props) {
  const [modalAudit, setModalAudit] = useState(false);
  const [modalSummary, setModalSummary] = useState(false);
  const [modalConflict, setModalConflict] = useState(false);
  const [modal, setModal] = useState({
    legend: false
  })
  const [positionName, setPositionName] = useState('');
  const [status, setStatus] = useState();
  const valx = {
    modalAudit,
    setModalAudit,
    status,
    setStatus,
    modalSummary,
    setModalSummary,
    positionName,
    setPositionName,
    modalConflict,
    setModalConflict,
    modal,
    setModal
  };
  return <Matrix.Provider value={valx}>{props.children}</Matrix.Provider>;
}

export default Index;
